import { ChangeDetectionStrategy, Component } from '@angular/core';
// eslint-disable-next-line @tseslint/no-unused-vars
import { OverviewHeaderComponent } from '../../overview-header.component';

/**
 * Add this Component to {@link OverviewHeaderComponent | app-overview-header} to add a Title
 *
 * @example
 *
 * ```html
 * <app-overview-header>
 *   <!-- other overview-header child-components... -->
 *   <app-overview-header-title>
 *     My Title
 *   </app-overview-header-title>
 *   <!-- other overview-header child-components... -->
 * </app-overview-header>
 * ```
 */
@Component({
  selector: 'app-overview-header-title',
  standalone: true,
  imports: [],
  templateUrl: './overview-header-title.component.html',
  styleUrl: './overview-header-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class OverviewHeaderTitleComponent {}
